export const RECORDING_TYPE = {
  FACE_RECORDING: 'face',
  SCREEN_RECORDING: 'screen',
  VOICE_RECORDING: 'voice',
  SCREEN_AND_VOICE: 'screen_and_voice',
  FINAL_RECORDING: 'final_recording',
};

export const SIDE_TABS = ['Transcripts', 'Notes & Clips'];
export const PROCESSED_STATUS = 'processed';
export const TRANSCRIBE_ERROR_STATUS = 'transcribe_error';
